export const QUALIFICATION_NAMES = Object.freeze({
  AGE: 'Age',
  NESTED: 'Nested',
});
